import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    width: 50%;
    padding-top: 200px;
  }
`;

export const STText = styled.span`
  && {
    font-size: 1.5rem;
    padding-bottom: 1rem;
  }
`;

export const STFormWrapper = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  margin-top: 24px;
  flex-direction: column;
`;
